// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Kenya */
const KE = /^(?:(?:1(?:0[0-8]|[18]\d|2[014]|30|4[0-5])|7\d\d)\d{6})$/;

export default KE;
